import * as yup from "yup";

const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(com|org|net|in|co\.in)$/i;

export const isValidEmail = (email: string) => EMAIL_REGEX.test(email.trim());

export const validateNoTrailingOrLeadingWhitespace = (fieldLabel: string) =>
  yup
    .string()
    .trim()
    .required(`${fieldLabel} is Required`)
    // .test(
    //   `not-only-spaces-${fieldLabel}`,
    //   "Empty whitespace not allowed in start and end",
    //   (value) => !!value && value.trim().length > 0
    // )
    // .test(
    //   `no-leading-trailing-space-${fieldLabel}`,
    //   "Empty whitespace not allowed in start and end",
    //   (value) => !!value && value === value.trim()
    // );


export const TrailingOrLeadingWhitespaceValidation = (fieldLabel: string) =>
  yup
    .string()
    // Do not use .trim() here, otherwise Yup mutates the string before the tests run
    .required(`${fieldLabel} is Required`)
    .test(
      `not-only-spaces-${fieldLabel}`,
      `${fieldLabel} cannot be only blank spaces`,
      (value) => !!value && value.trim().length > 0
    )
    .test(
      `no-leading-trailing-space-${fieldLabel}`,
      "Empty whitespace not allowed in start and end",
      (value) => !!value && value === value.trim()
    );

export const validateNoLeadingTrailingWhitespace = (value?: string) => {
  if (!value) return true; // Let .required() handle empty states
  return value.trim().length > 0; // Fails if the user enters ONLY spaces
};

/**
 * Formats IFSC input by removing non-alphanumeric characters 
 * and forcing the string to uppercase.
 */
export const handleIFSCInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;

  // Replace anything that is NOT a letter or number, then uppercase it
  const formattedValue = target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

  // Enforce max length of 11 at the DOM level (optional but recommended)
  target.value = formattedValue.slice(0, 11);
};

/**
 * Validates an Indian Financial System Code (IFSC)
 * Standard: 4 Alphabets + 1 Zero + 6 Alphanumeric characters (Total exactly 11)
 */
export const validateIFSCCode = (ifsc: string | undefined | null): boolean => {
  if (!ifsc) return false;

  // Trim to ignore accidental leading/trailing spaces
  const cleanIFSC = ifsc.trim();

  // Regex pattern for IFSC
  const ifscRegex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;

  return ifscRegex.test(cleanIFSC);
};